import { ChangeEvent, memo } from 'react';
import { Box, FormControl, TextField } from '@mui/material';

import { TwoFactorAuthenticationType } from '@/legacy/features/user/twoFactorAuthentication/twoFactorAuthentication';
import { getFieldError } from '@/legacy/utils/reactHelpers';

import SmsBackupOptions from '../shared/SmsBackupOptionsFragment';

import CodeMessage from './CodeMessageFragment';

interface FieldError {
  errors: Array<string>;
  name: string;
}

interface Props {
  code: string;
  fieldErrors: Array<FieldError>;
  isEnabled: boolean;
  isLoading: boolean;
  onCodeChange: { (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void };
  onResendCode: () => void;
  onCallMe: () => void;
  phoneNumber: string;
  verificationMethod: TwoFactorAuthenticationType;
}

const Code = (props: Props): React.JSX.Element => {
  const {
    code,
    fieldErrors,
    isEnabled,
    isLoading,
    onCodeChange,
    onResendCode,
    onCallMe,
    phoneNumber,
    verificationMethod,
  } = props;

  const getCodeLabel = () => {
    switch (verificationMethod) {
      case TwoFactorAuthenticationType.Sms:
        return 'Enter SMS Code';

      case TwoFactorAuthenticationType.Otp:
        return 'Enter Authenticator Code';

      default:
        return null;
    }
  };

  return (
    <>
      <Box mt={2} mb={3}>
        <CodeMessage
          isEnabled={isEnabled}
          phoneNumber={phoneNumber}
          verificationMethod={verificationMethod}
        />
      </Box>
      <Box my={3}>
        <FormControl variant="outlined" fullWidth>
          <TextField
            id="code"
            value={code}
            onChange={onCodeChange}
            label={getCodeLabel()}
            autoFocus
            disabled={isLoading}
            error={Boolean(getFieldError('code', fieldErrors))}
            helperText={getFieldError('code', fieldErrors)}
            required
            autoComplete="off"
          />
        </FormControl>

        {verificationMethod === TwoFactorAuthenticationType.Sms && (
          <SmsBackupOptions onResendCode={onResendCode} onCallMe={onCallMe} />
        )}
      </Box>
    </>
  );
};

export default memo(Code);
